<div class="container-fluid">
  <mat-tab-group>
    <mat-tab label="Maintenances">
      <ng-template matTabContent>
        <app-admin-maintenances></app-admin-maintenances>
      </ng-template>
    </mat-tab>
    <mat-tab label="Connecteurs">
      <ng-template matTabContent>
        <app-admin-connectors></app-admin-connectors>
      </ng-template>
    </mat-tab>
    <mat-tab label="Attributs">
      <ng-template matTabContent>
        <app-admin-attributes></app-admin-attributes>
      </ng-template>
    </mat-tab>
    <mat-tab label="Groupes d'attributs">
      <ng-template matTabContent>
        <app-admin-attribute-groups></app-admin-attribute-groups>
      </ng-template>
    </mat-tab>
    <mat-tab label="Outils">
      <ng-template matTabContent>
        <app-admin-tools></app-admin-tools>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>